<template>
  <div class="post type-post hentry">
    <h2>Kontaktai</h2>
    <div class="entry">
      <div style="display: flex">
        <div class="left">
          <p>
            El. paštas <a href="mailto:rdamusis@gmail.com">RDamusis@gmail.com</a>,
            <a href="mailto:romaldas@damusis.lt">Romaldas@Damusis.lt</a>
          </p>
          <p>
            Laiškus Krikščionių partijos ir vietos savivaldos reikalais siųsti šiuo
            adresu:
            <a href="mailto:sakiai@krikscioniupartija.lt"
              >sakiai@krikscioniupartija.lt</a
            >
          </p>
          <p>Telefonai 8-345-60282, 8-686-79-155,</p>
          <p>
            Tose pačiose patalpose veikia Šakių rajono antrasis notaro biuras.<br />
          </p>
        </div>
        <div class="right">
          <p>
            <img title="Biuras" src="/assets/biuras.jpg" alt="Biuras" width="326" height="220">
          </p>
        </div>
      </div>
      <div class="map-container">
        <Map />
      </div>
    </div>
  </div>
</template>

<script>
import Map from '@/components/Map'

export default {
  components: {
    Map
  }
}
</script>

<style>
.map-container {
  margin-top: 20px;
}
</style>
